import styled from 'styled-components';
import { __ } from '@web-stories-wp/i18n';
import VideoProps from '../propsTypes/video';
import ExternalMediaRow from './externalMediaRow';
import { useCallback, useRef, useState } from 'react';
import LoadingPill, { useShowLoadingPill } from '../../../common/loadingPill';
import MediaError from '../../common/mediaError';
import { useMemo } from '@web-stories-wp/react';
import useThumbnailLoadGate from '../../common/useThumbnailLoadGate';

const NoMediaFound = styled.div`
  text-align: center;
  margin-top: 24px;
`;

const ExternalMediaListContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  margin-right: 2px;
  padding: 0px 0px 20px 12px;
`;

function ExternalMediaList({
  assets,
  providerType,
  isLoading,
  loadAssets,
  hasMore,
  hasError,
  enableDeletion,
  enableEditInAzzuu,
  isActive,
  resetKey,
}) {
  const showLoadingPill = useShowLoadingPill(isLoading);
  const [expandedMenuId, setExpandedMenuId] = useState(null);
  const observer = useRef();
  const listContainerRef = useRef();
  const lastMediaElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadAssets({ isInitLoad: false });
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading, loadAssets]
  );
  const resourceIds = useMemo(() => assets.map((asset) => asset.id), [assets]);
  const { isBatchReady, onThumbnailReady } = useThumbnailLoadGate({
    resourceIds,
    resetKey,
    isActive,
  });

  return (
    <ExternalMediaListContainer ref={listContainerRef}>
      {hasError && (
        <MediaError
          onRetry={() => loadAssets({ isInitLoad: assets.length === 0 })}
        />
      )}

      {!hasError && (
        <>
          {(!assets || assets.length == 0) && !isLoading ? (
            <NoMediaFound>No media found.</NoMediaFound>
          ) : (
            assets.map((asset, index) => {
              const isLastElement = assets.length === index + 1;

              return (
                <ExternalMediaRow
                  key={`${asset.id}-${index}`}
                  asset={asset}
                  providerType={providerType}
                  isEditMenuExpanded={expandedMenuId === asset.id}
                  listContainerRef={listContainerRef}
                  lastElementRef={
                    isLastElement ? lastMediaElementRef : undefined
                  }
                  enableDeletion={enableDeletion}
                  enableEditInAzzuu={enableEditInAzzuu}
                  setExpandedMenuId={setExpandedMenuId}
                  isThumbnailBatchReady={isBatchReady}
                  onThumbnailReady={onThumbnailReady}
                />
              );
            })
          )}
        </>
      )}

      {showLoadingPill && <LoadingPill />}
    </ExternalMediaListContainer>
  );
}

ExternalMediaList.propTypes = {
  video: VideoProps,
};

export default ExternalMediaList;
